import { sortBy } from 'lodash'
import { formatCentsToCurrency } from 'utils/price'

const generateSummary = data => {
  if (!data) return ''

  const reason = data.reason || ''
  const quantity = data.quantity || 0
  const feeChargeCents = data.feeChargeCents || 0

  const cost = formatCentsToCurrency(feeChargeCents)
  const price = formatCentsToCurrency(quantity * feeChargeCents)

  return `${reason} ${quantity} qty x ${cost} = ${price}`
}

export default function feeTaxLineBuilder(builder, payload = {}) {
  const { feeTaxLinesById } = payload || {}

  if (!feeTaxLinesById) return

  Object.values(feeTaxLinesById).forEach(versions => {
    if (!Array.isArray(versions) || versions.length === 0) return

    const sorted = sortBy(versions, v => Number(v?.rev ?? 0))

    for (let i = 0; i < sorted.length; i++) {
      const current = sorted[i]
      const prev = sorted[i - 1]
      const rev = current?.rev
      const revType = String(current?.revType || current?.type || '').toUpperCase()

      let action = 'Updated'
      if (revType === 'INSERT') action = 'Added'
      if (revType === 'DELETE') action = 'Deleted'

      let newValue
      let oldValue

      if (action === 'Added') {
        newValue = { ...current }
        newValue.toString = () => generateSummary(current)
      } else if (action === 'Updated') {
        newValue = { ...current }
        newValue.toString = () => generateSummary(current)
        if (prev) {
          oldValue = { ...prev }
          oldValue.toString = () => generateSummary(prev)
        }
      } else if (action === 'Deleted') {
        oldValue = { ...current }
        oldValue.toString = () => generateSummary(current)
      }

      builder.addCustomChange(rev, current, {
        field: 'General Fee',
        fieldKey: 'generalFee',
        oldValue,
        newValue,
        changeType: action,
        renderRawValue: true,
      })
    }
  })
}
